module.exports = __webpack_public_path__ + "img/selected0-min.d955b7a1.png";